import React from 'react';
import ReactDOM from 'react-dom';
import QuantitySelect from 'components/QuantitySelect';


export default (selector) => {
    const quantitySelects = [...document.querySelectorAll(selector)];
    quantitySelects.forEach((quantitySelect) => {
        ReactDOM.render(<QuantitySelect />, quantitySelect);
    });
};



// WEBPACK FOOTER //
// ./src/widgets/QuantitySelect.js